import * as R from 'ramda'
import { login, JWTLogin, logout, getUserData } from '../../helpers/api/api'
import { errorToBeAdded } from '../error'

import {
  clearError,
  startLoading,
  stopLoading,
  saveErrorMsg,
} from '../../helpers/api/meta'
import { LOGIN_SUCCESS } from '../../components/socialWall/constants/authConstants'

export const SIGNIN_STARTED = 'SIGNIN_STARTED'
export const SIGNIN_SUCCESS = 'SIGNIN_SUCCESS'
export const SIGNIN_FAILURE = 'SIGNIN_FAILURE'
export const SIGNIN_ENDED = 'SIGNIN_ENDED'

export const SIGNOUT_SUCCESS = 'SIGNOUT_SUCCESS';

export const signinStarted = () => ({ type: SIGNIN_STARTED })
export const signinSuccess = success => ({ type: SIGNIN_SUCCESS, success })
export const signinFailure = error => ({ type: SIGNIN_FAILURE, error })
export const signinEnded = () => ({ type: SIGNIN_ENDED })

export const signoutSuccess = () => ({ type: SIGNOUT_SUCCESS, authorized: false });

export const LOAD_USER_STARTED = 'LOAD_USER_STARTED'
export const LOAD_USER_SUCCESS = 'LOAD_USER_SUCCESS'
export const LOAD_USER_FAILURE = 'LOAD_USER_FAILURE'
export const LOAD_USER_ENDED = 'LOAD_USER_ENDED'

export const loadUserStarted = () => ({ type: LOAD_USER_STARTED })
export const loadUserSuccess = success => ({ type: LOAD_USER_SUCCESS, success })
export const loadUserFailure = error => ({ type: LOAD_USER_FAILURE, error })
export const loadUserEnded = () => ({ type: LOAD_USER_ENDED });
export const loginUser = (data) => ({
  type: LOGIN_SUCCESS,
  payload: { 
    access: true,
    refresh: true,
    isAuthenticated: true,
    isLoading: false,
    user: data, }
})

const updateState = (state, action) => {
  let res = action.success ? R.mergeDeepRight(state, { authorized: true, ...action.success }) : state
  return res
}

const updateError = (state, action) => {
  let res = R.mergeDeepRight(state, { authorized: false, error: action.error })
  return res
}

const messages = {
  signinFailed: 'Invalid domain, user name or password',
  loadUserFailed: 'Could not load user details'
};

const initialState = {
  authorized: false,
  loading: false,
  role: {
    id: null,
    name: null
  },
  is_approved: false
}

export const signin = body => (dispatch) => {
  dispatch(signinStarted())
  return login(body)
    .then((success) => {
      if (success.auth_token !== undefined) {
        window.localStorage.setItem('token', success.auth_token)
        document.cookie = `token=${success.auth_token}`;
        dispatch(signinEnded())
        dispatch(signinSuccess(success))
        if (body.rememberme) {
          window.localStorage.setItem('rememberMe', JSON.stringify(body))
        }
        return success
      } else {
        return success
      }

    })
    .catch((error) => {
      dispatch(signinEnded())
      dispatch(errorToBeAdded(error, 'signinFailure', messages.signinFailed))
      dispatch(signinFailure(error))
    })
}

export const JWTSignIn = body => (dispatch) => {
  dispatch(signinStarted())
  return JWTLogin(body)
    .then((success) => {
      window.localStorage.setItem('access_token', success.access)
      window.localStorage.setItem('refresh_token', success.refresh)
      dispatch(signinEnded())
      dispatch(signinSuccess(success))
    })
    .catch((error) => {
      dispatch(signinEnded())
      dispatch(errorToBeAdded(error, 'signinFailure', messages.signinFailed))
      dispatch(signinFailure(error))
    })
}

export const signout = () => (dispatch) => {
  return logout()
    .then(() => {
      dispatch(signoutSuccess())
      window.location.href = '/'
      // window.localStorage.removeItem('token')
    })
    .catch(() => {
      dispatch(signoutSuccess())
      window.location.href = '/'
      // window.localStorage.removeItem('token')
    })
}

export const loadUserData = () => (dispatch) => {
  dispatch(loadUserStarted())
  return getUserData()
    .then((success) => {
      if(success===undefined){
        localStorage.setItem('token', '')
        window.location.href = '/'
      }
      dispatch(loadUserEnded())
      dispatch(loadUserSuccess(success));
      dispatch(loginUser(success));
    })
    .catch((error) => {
      window.localStorage.removeItem('token')
      window.location.href = '/'
      dispatch(loadUserEnded())
      dispatch(loadUserFailure(error))
    })
}

export default function sessionReducer(state = initialState, action) {
  switch (action.type) {
    case SIGNIN_STARTED: {
      return startLoading(clearError(state))
    }
    case SIGNIN_SUCCESS: {
      return updateState(state, action)
    }
    case SIGNIN_FAILURE: {
      return updateError(state, action)
    }
    case SIGNIN_ENDED: {
      return stopLoading(state)
    }
    case SIGNOUT_SUCCESS: {
      return updateState(state, action)
    }
    case LOAD_USER_STARTED: {
      return startLoading(clearError(state))
    }
    case LOAD_USER_SUCCESS: {
      return updateState(state, action)
    }
    case LOAD_USER_FAILURE: {
      return saveErrorMsg(initialState, action, messages.loadUserFailed)
    }
    case LOAD_USER_ENDED: {
      return stopLoading(state)
    }
    default:
      return state
  }
}